import React from 'react';
import { connect } from 'react-redux';
import { toArray, checkUserForFullAuthorization } from 'src/util/Util';

const RenderIfHasPermissions = ({
    userPermissions,
    requiredPermissions,
    children,
    allowIfAnyOneOfPermissionPresent = false,
}) => {
    if (checkUserForFullAuthorization()) {
        return <>{children}</>;
    }

    if (!requiredPermissions || requiredPermissions.length === 0) {
        return null;
    }

    let hasPermissions = false;
    if (allowIfAnyOneOfPermissionPresent) {
        hasPermissions = requiredPermissions.some(permission => userPermissions.includes(permission));
    } else {
        hasPermissions = requiredPermissions.every(permission => userPermissions.includes(permission));
    }

    if (hasPermissions) {
        return <>{children}</>;
    }

    return null;
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => {
    const permissions = toArray(state.oidc.getIn(['user', 'profile', 'permissions']));
    return {
        userPermissions: permissions,
    };
};

export default connect(mapStateToProps)(RenderIfHasPermissions);
